module.exports = __webpack_public_path__ + "static/media/icon-parents.fbc77393.svg";